import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { formatDate } from "@/lib/format";
import { toast } from "sonner";
import { Check, X, Inbox } from "lucide-react";

export const TalentApplications = ({ applications, onChange }) => {
  const review = async (t, action) => {
    try {
      await api.post(`/talents/${t.id}/review`, null, { params: { action } });
      toast.success(action === "approve" ? `${t.name} disetujui & sudah bisa login` : `Pengajuan ${t.name} ditolak`);
      onChange();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  if (applications.length === 0) return null;

  return (
    <div className="bg-card border border-amber-500/30 rounded-xl p-5" data-testid="talent-applications-section">
      <h3 className="font-semibold mb-4 flex items-center gap-2">
        <Inbox className="h-4 w-4 text-amber-400" /> Pengajuan Talent Baru
        <span className="text-xs px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-400" data-testid="applications-count">{applications.length}</span>
      </h3>
      <div className="space-y-2">
        {applications.map((t) => (
          <div key={t.id} className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-background rounded-lg p-4" data-testid={`application-row-${t.id}`}>
            <div className="min-w-0 space-y-1">
              <p className="font-medium flex items-center gap-2">{t.name} <StatusBadge status={t.status} /></p>
              <p className="text-xs text-muted-foreground">
                {t.email} • {t.phone} • <span className="font-mono text-cyan-400">{t.tiktok_handle}</span>
              </p>
              <p className="text-xs text-muted-foreground font-mono">{t.bank_name} • {t.account_number || "-"} • diajukan {formatDate(t.created_at)}</p>
              {t.application_note && <p className="text-xs text-muted-foreground italic">"{t.application_note}"</p>}
            </div>
            <div className="flex gap-2 shrink-0">
              <Button size="sm" data-testid={`approve-talent-${t.id}`} onClick={() => review(t, "approve")} className="bg-emerald-600 hover:bg-emerald-500 text-white">
                <Check className="h-4 w-4 mr-1" /> Setujui
              </Button>
              {t.status === "pending" && (
                <Button size="sm" variant="outline" data-testid={`reject-talent-${t.id}`} onClick={() => review(t, "reject")} className="border-border hover:text-destructive">
                  <X className="h-4 w-4 mr-1" /> Tolak
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
